// src/screens/Marketplace/DepartmentsAll.js
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DEPARTMENTS, DEPARTMENT_OTHER } from '../../constants/departments';
import backIcon from '../../assets/backspace-icon.png';
import './DepartmentsAll.css';

export default function DepartmentsAll() {
  const navigate = useNavigate();
  const items = useMemo(() => [...DEPARTMENTS, DEPARTMENT_OTHER], []);

  return (
    <div className="dal-page">
      {/* Fixed Top Bar */}
      <header className="dal-topbar">
        <button
          className="dal-back"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          title="Back"
        >
          <img src={backIcon} alt="" className="dal-back-img" />
        </button>
        <h1 className="dal-title">SHOP BY DEPARTMENT</h1>
        <div className="dal-spacer" />
      </header>

      {/* Scrollable Content */}
      <div className="dal-scroll">
        <div className="dal-list">
          {items.map((d) => (
            <button
              key={d.key}
              className="dal-row"
              onClick={() => navigate(`/marketplace/department/${d.key}`)}
              title={d.label}
              aria-label={`Open ${d.label}`}
            >
              <span className="dal-emoji" aria-hidden>{d.emoji}</span>
              <span className="dal-label">{d.label}</span>
              <svg className="dal-chevron" width="18" height="18" viewBox="0 0 24 24" aria-hidden>
                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
